import Radios from 'components/Formik/Radios';
import Checkboxes from 'components/Formik/Checkboxes';
import Text from 'components/Formik/Text';
import { useEffect } from 'react';
import TextArea from 'components/Formik/TextArea';

const HeartValve = ({ formik, initialValues, data }) => {
	initialValues.heartValve = '';
	initialValues.valveTreatementReceivedandDates = '';
	initialValues.LblheartValveProduct = '';
	initialValues.modelNumber = '';
	initialValues.Hospital__c = '';
	useEffect(() => {
		formik.values.valveTreatmentReceivedandDates = '';
		formik.values.LblheartValveProduct = '';
		formik.values.modelNumber = '';
		formik.values.Hospital__c = '';
	}, [formik.values.heartValve]);
	const {
		heart_valve,
		date_of_procedures,
		your_edwards_products,
		serial_number,
		treating_physicians,
		hospital,
	} = data;
	return (
		<div>
			<p>
				<strong>{heart_valve.label}</strong>
			</p>
			<Radios options={heart_valve.options} name='heartValve' />
			{formik.values.heartValve === 'yes' && (
				<>
					<TextArea label={date_of_procedures} name='valveTreatmentsReceivedandDates' />
					<p>
						<strong>{your_edwards_products.label}</strong>
					</p>
					<Checkboxes
						options={your_edwards_products.options}
						label='heartValveProduct'
						name='LblheartValveProduct'
						split
					/>
					<Text label={serial_number} name='modelNumber' type='text' />
					<div className='grid-lg-2 row-gap-0'>
						<Text label={treating_physicians} name='treatingPhysician' type='text' />
						<Text label={`${hospital}:`} name='Hospital__c' type='text' />
					</div>
				</>
			)}
		</div>
	);
};

export default HeartValve;
